import React from "react";
import { Box } from "@mui/material";
import { CustomTypography } from "../../Shared/CustomTypography/CustomTypography";

interface InfoCardProps {
  title: string;
  bg: string;
  children: React.ReactNode;
}

export const InfoCard: React.FC<InfoCardProps> = ({ title, bg, children }) => (
  <Box
    bgcolor={bg}
    borderRadius={3}
    p={2}
    mb={2}
    boxShadow="0px 2px 10px rgba(0,0,0,0.05)"
  >
    <CustomTypography fontWeight={600} mb={1}>
      {title}
    </CustomTypography>
    {children}
  </Box>
);
